/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import ChatInitializerContext from "./ChatInitializerContext";
import ChatContext from "./ChatContext";
import AppContext from "AppContext";
import NotificationsIndicator from "components/Home/Notifications/Indicator";
import { hasElements } from "utils/arrays";
import { useNotifications } from "components/Home/Notifications/Notifications";

function Conversation({ conversation, onClick, isSelected }) {
    const { clientPhotoResolver, conversationNameResolver } = useContext(ChatInitializerContext);
    const { profile } = useContext(ChatContext);
    const notifications = useNotifications(`conversation-${conversation?.sid}`);
    const {
        api: {
            Chat: { Notifications },
        },
        markCachedNotificationsAsRead,
    } = useContext(AppContext);

    const [friendlyName, setFriendlyName] = useState(conversation.friendlyName || conversation.sid);

    useEffect(() => {
        const getClientInfoAsync = async () => {
            try {
                if (conversationNameResolver) {
                    const fName = await conversationNameResolver(conversation);
                    setFriendlyName(fName);
                }
            } catch (error) {
                console.error("The client info couldn't be loaded.", error);
            }
        };
        getClientInfoAsync();
    }, []);

    const notificationsGetter = () => {
        return notifications?.[profile]?.filter((n) => n.conversationSid === conversation.sid);
    };

    const onClickHandler = async () => {
        onClick();
        // Mark notifications as read
        const _notifications = notificationsGetter();
        if (hasElements(_notifications)) {
            const notificationIds = _notifications.map((x) => x.id);
            await Notifications.markNotificationsAsRead(notificationIds);
            // Clear notifications
            markCachedNotificationsAsRead(profile, notificationIds);
        }
    };

    return (
        <div className={clsx("conversation", { active: isSelected })} onClick={onClickHandler}>
            <div className="info-container">
                <div
                    className="photo"
                    style={{
                        backgroundImage: `url(${clientPhotoResolver(conversation)})`,
                    }}
                />
                <div className="info">
                    <p className="name">{friendlyName}</p>
                </div>
            </div>
            <div className="extra-info">
                {conversation.state.current === "active" ? (
                    <NotificationsIndicator id={`conversation-${conversation?.sid}`} identity={profile} getter={notificationsGetter} />
                ) : (
                    <div className="state">{conversation.state.current}</div>
                )}
            </div>
        </div>
    );
}

Conversation.propTypes = {
    conversation: PropTypes.shape({ friendlyName: PropTypes.string, sid: PropTypes.string }).isRequired,
    onClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
};

export default Conversation;
